module.exports = __webpack_public_path__ + "img/mailjet_logo.3ab95eed.svg";